import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import * as S from "./HomeSearchWidget.styles";
import dateformat from "dateformat";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../../../../stories/core-components/IconsSelector";
import AutoSuggest from "../../../../components/autosuggest/autosuggest";
import CustomRadioButton from "../../../../../stories/core-components/CustomRadioButtonUI/CustomRadioButtonUI";
import TimeDropdown from "../../../../../stories/components/cars/homepage/TimeDropdown/TimeDropdownUI";
import Calendar from "../../../../components/calendar/calendar";
import { 
  BLANK_VALUE, 
  FLIGHTS_MYTRIPS_DETAILS_PAGE, 
  FLIGHTS_MYTRIPS_DETAILS_PAGE_NEW, 
  HOME_DROP_ERROR_TXT, 
  HOME_PACKAGE_ERROR_TXT, 
  HOME_PICKUP_DROP_SAME_ERROR_TXT, 
  HOME_PICKUP_ERROR_TXT, 
  HOME_STOP_ERROR_TXT,
  tripAttributes 
} from "../../../../config/constants";
import {
  tripTypeSelector,
  sourceSelector,
  destinationSelector,
  startDateSelector,
  endDateSelector,
  isSeoSelector,
  hrPackageSelector,
  homeHourlyRentalPackageSelector,
  flowSelector,
  multicityStopOversSelector,
  cabsConfigDataSelector,
  previousMulticityStopOversSelector,
  showRTRevampSelector,
  rtRevampSelector,
  rtRevampLandingRTSelector,
  rtRevampToastTimeSelector
} from "../../../../common/redux/selector";
import { popularSearchSelector } from '../../redux/selector';
import useOutsideClick from "../../../../hooks/useOutsideClick";
import useNavigate from "../../../../hooks/useNavigate";
import { recentSearchStore, getRecentSearches, getTodaysDate, getDateForHome } from "../../../../config/utils";
import { pageView } from "../../../../config/ga";
import addDays from "../../../../../../utils/date-utils/addDays";
import { CTA_TYPE, getActionNameForOmniture, getTripTypeForOmniture, pushOmniEvents } from "../../../../../shared/utils/omni-utils";
import { gcHomeScreen, get24HoursTime, getCtaProperty, getLoadedComponent, getRouteDetails, getTripDays, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { fetchModalInfoAndPackageDetails } from "../../../../../shared/common/redux/thunks";
import CabHourlyCarouselUI from "../../../../../shared/containers/CabHourlyCarousel/CabHourlyCarouselUI";
import dateFormat from 'dateformat'
import { 
  dateTypeFormat, 
  ROUND_TRIP, 
  timeTypeFormat, 
  RouteCountry, 
  ADDRESS_SWAP, 
  CABS_LANDING_ROUTE, 
  CABS_LISTING_ROUTE, 
  HOME_SEARCH_WIDGET, 
  SEARCH, 
  PICKUP_TIME_CALANDER, 
  RETURN_TIME_CALANDER, 
  PICKUP_DATE_CALANDER, 
  PICKUP_TIME_UPDATE, 
  RETURN_TIME_UPDATE, 
  RETURN_DATE_CALANDER, 
  PICKUP_ERROR, 
  MOB_CABS_LANDING, 
  DROP_ERROR, 
  SELECT_PACKAGE_ERROR, 
  PICKUP_DROP_SAME_ERROR, 
  ADD_STOP, 
  CLICKED, 
  REMOVE_STOP, 
  STOP_EMPTY_ERROR 
} from "../../../../../shared/utils/util-constants";
import { UPDATE_MULTICITY_STOPOVERS, UPDATE_PREVIOUS_MULTICITY_STOPOVERS } from "../../../SearchPage/redux/action-types";

let rtToastShown = false

const HomeSearchWidget = () => {
  const searchWidgetRef = React.createRef();
  const dispatch = useDispatch();
  const triptype = useSelector(tripTypeSelector);
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const startDate = useSelector(startDateSelector);
  const endDate = useSelector(endDateSelector);
  const hrSelectedPackageId : string = useSelector(hrPackageSelector)
  const hrPackageDetails = useSelector(homeHourlyRentalPackageSelector)
  const popularSearch = useSelector(popularSearchSelector);
  const stopOvers = useSelector(multicityStopOversSelector)
  const previousStopOvers = useSelector(previousMulticityStopOversSelector)
  const isSeo = useSelector(isSeoSelector);
  const flow = useSelector(flowSelector)
  const configData = useSelector(cabsConfigDataSelector)
  const isRTRevamp = useSelector(showRTRevampSelector)
  const rtRevampText = useSelector(rtRevampSelector);
  const rtText = useSelector(rtRevampLandingRTSelector)
  const rtToastOpenTime = useSelector(rtRevampToastTimeSelector)
  const { date, time } = startDate;
  const { date: enddate, time: endTime } = endDate;

  const [showWidget, setWidget] = useState("");
  const [autofocusIndex, setAutoFocusIndex] = useState(-1)
  const [isSearchClicked, setIsSearchClicked] = useState(false)
  const [formError, setFormError] = useState({
    pickupError : null,
    dropError: null,
    packageError: null,
    stopOversError: null
  })
  const [navigateTo] = useNavigate();

  useOutsideClick(searchWidgetRef, () => {
    setWidget("");
  });

  useEffect(() => {
    if (stopOvers?.length) {
      const index = stopOvers.findIndex(stop => !stop?.value?.name)
      if (index > -1) {
        setAutoFocusIndex(index)
      }
    } else {
      setAutoFocusIndex(-1)
    }
  }, [stopOvers])

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(()=>{
    if(triptype?.rf === "rt" && isRTRevamp && !rtToastShown){
      setWidget("returntime");
      setTimeout(() => {
        setWidget("")
        rtToastShown = true
      },rtToastOpenTime)
    }
  },[triptype.rf, isRTRevamp, rtToastOpenTime])

  useEffect(() => {
    if (isSearchClicked) {
      const newFormError = checkFormError(false)
      setFormError(newFormError)
    }
  }, [source, destination, triptype, isSearchClicked, hrSelectedPackageId, stopOvers])
  

  const prevStore = usePrevious({ triptype });

  const recentSearchUpdate = () => {
    const data = getRecentSearches({ type: triptype?.rf });
    if ((!data.length && prevStore?.triptype?.rf !== 'at')) {
      return false;
    }
    let len = 0;
    const defaultDate = getDateForHome(1);
    const isToday = !!(getTodaysDate() > new Date(startDate.date));
    while (len !== data.length) {
      const { startDate } = data[len];
      if (isToday) {
        if (defaultDate.toDateString() === new Date(startDate.date).toDateString()) {
          break;
        }
        ++len;
      } else {
        break;
      }
    }
    if (data[len]) {
      const sDate = new Date() >= new Date(data[len].startDate.date) ? defaultDate : data[len].startDate.date;
      const newDate = new Date(sDate);
      data[len].startDate.date = newDate;
      data[len].startDate.time = dateformat(getDateForHome(1), 'hh:MM TT');
      data[len].endDate.date = new Date() >= new Date(data[len].endDate.date) ? addDays(newDate, 1) : new Date(`${data[len].endDate.date}`);
      data[len].endDate.time = dateformat(getDateForHome(2), 'hh:MM TT')
    }
    dispatch({
      type: 'UPDATE_RECENT_SEARCH',
      data: data[len] ? data[len] : null
    });
  }

  useEffect(() => {
    if (!isSeo && flow !== FLIGHTS_MYTRIPS_DETAILS_PAGE && flow !== FLIGHTS_MYTRIPS_DETAILS_PAGE_NEW) {
      recentSearchUpdate();
    }
  }, [triptype?.rf]);

  useEffect(() => {
    getLoadedComponent('HomeSearchWidget')
    setTimeout(() => {
      dispatch(pageView());
    }, 3000)
  }, []);

  useEffect(() => {
    if (!Object.keys(hrPackageDetails)?.length) {
      dispatch(fetchModalInfoAndPackageDetails())
    }
  }, [hrPackageDetails])

  const updateTime = useCallback(
    (time, isPickup) => {
      setWidget("");
      pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, isPickup ? PICKUP_TIME_UPDATE : RETURN_TIME_UPDATE), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
      dispatch({
        type: isPickup ? "UPDATE_START_TIME" : "UPDATE_END_TIME",
        time,
      });
    },
    [dispatch]
  );

  const updateTripType = useCallback(
    (tripType, rf) => {
      const btnName : string = getTripTypeForOmniture(tripType)
      pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, btnName), CTA_TYPE.RADIO_BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
      dispatch({
        type: "UPDATE_TRIP_TYPE",
        tripType: {
          name: tripType,
          rf
        }
      });
    },
    [dispatch]
  );

  const onSwap = () => {
    pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, ADDRESS_SWAP), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
    dispatch({
      type: "UPDATE_SRC_AND_DESC"
    });
  }

  const checkFormError = (checkStopError : boolean = true) => {
    let tripTypeVal = ''
    if (triptype?.rf === 'hr') {
      tripTypeVal = 'rental'
    } else if (triptype?.rf === 'at') {
      tripTypeVal = 'airport'
    } else {
      tripTypeVal = 'outstation'
    }
    let newFormError = {...formError}
    if (!source?.name) {
      newFormError['pickupError'] = HOME_PICKUP_ERROR_TXT
      pushCtaOmniEvents(`${MOB_CABS_LANDING}_${tripTypeVal}_${PICKUP_ERROR}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
    } else newFormError['pickupError'] = null

    if (triptype?.rf !== 'hr' && !destination?.name) {
      newFormError['dropError'] = HOME_DROP_ERROR_TXT
      pushCtaOmniEvents(`${MOB_CABS_LANDING}_${tripTypeVal}_${DROP_ERROR}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
    } else newFormError['dropError'] = null

    if (triptype?.rf === 'hr' && !hrSelectedPackageId?.length) {
      newFormError['packageError'] = HOME_PACKAGE_ERROR_TXT
      pushCtaOmniEvents(`${MOB_CABS_LANDING}_rental_${SELECT_PACKAGE_ERROR}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
    } else newFormError['packageError'] = null

    if (!newFormError?.dropError) {
      if (source?.place_id === destination?.place_id) {
        !newFormError?.dropError ? newFormError['dropError'] = HOME_PICKUP_DROP_SAME_ERROR_TXT : ''
        pushCtaOmniEvents(`${MOB_CABS_LANDING}_${tripTypeVal}_${PICKUP_DROP_SAME_ERROR}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
      } else newFormError['dropError'] = null
    }

    if (stopOvers?.length && checkStopError) {
      const stopVal = stopOvers?.find(item => !item?.value?.name)
      if (stopVal) {
        pushCtaOmniEvents(`${MOB_CABS_LANDING}_${tripTypeVal}_${STOP_EMPTY_ERROR}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
        newFormError['stopOversError'] = HOME_STOP_ERROR_TXT
      } else newFormError['stopOversError'] = null
    } else newFormError['stopOversError'] = null
    return newFormError
  }

  const onSearch = () => {
    setIsSearchClicked(true)
    const newFormError = checkFormError()
    setFormError(newFormError)
    if (newFormError?.pickupError || newFormError?.dropError || newFormError?.packageError || newFormError?.stopOversError) return
    const hrDest = {
      city_name: BLANK_VALUE,
      name: BLANK_VALUE,
      place_id: BLANK_VALUE,
      state: BLANK_VALUE,
      lobCity: BLANK_VALUE,
      loc_type: BLANK_VALUE,
      locus: {}
    }
    const dest = triptype?.rf === 'hr' ? hrDest : destination;
    navigateTo("srp");
    recentSearchStore({ source, destination: dest, startDate, endDate, triptype, package_id: hrSelectedPackageId });

    const startTimeDetails  : string = `${dateFormat(startDate?.date, 'yyyy-mm-dd')}T${get24HoursTime(startDate?.time)}`
    const endTimeDetails    : string = `${dateFormat(endDate?.date, 'yyyy-mm-dd')}T${get24HoursTime(endDate?.time)}`

    const eventDetails = {
      cta: getCtaProperty(getActionNameForOmniture(gcHomeScreen, SEARCH), CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LISTING_ROUTE),
      booking: {
        tripType: `${triptype?.name}`,
        routeCity: triptype?.rf === 'hr' ? getRouteDetails(source?.city_name ? source?.city_name : source?.name, '') : getRouteDetails(source?.city_name ? source?.city_name : source?.name, destination?.city_name ? destination?.city_name : destination?.name),
        routeState: triptype?.rf === 'hr' ? getRouteDetails(source?.state, '') : getRouteDetails(source?.state, destination?.state),
        routeCountry: RouteCountry,
        departureDate: `${dateFormat(startDate?.date, dateTypeFormat)}`,
        departureTime: startDate?.time ? `${dateFormat(startTimeDetails, timeTypeFormat)}` : `${dateFormat(startDate?.date, timeTypeFormat)}`,
        daysToTrip: startDate?.time ? getTripDays(new Date().toString(), startTimeDetails) : getTripDays(new Date().toString(), startDate?.date)
      }
    }

    if (triptype?.rf === 'hr') {
      eventDetails.booking["packageId"] = hrSelectedPackageId
    }

    if (triptype?.name === ROUND_TRIP) {
      eventDetails.booking["returnDate"]  = `${dateFormat(endDate?.date, dateTypeFormat)}`
      eventDetails.booking["returnTime"]  = endDate?.time ? `${dateFormat(endTimeDetails, timeTypeFormat)}` : `${dateFormat(endDate?.date, timeTypeFormat)}`
      eventDetails.booking["duration"]    = endDate?.time && startDate?.time ? getTripDays(startTimeDetails, endTimeDetails) : getTripDays(startDate?.date, endDate?.date)
    }

    pushOmniEvents({eventName : "searchCabs", details: eventDetails})
  }

  const stopOversStr = useCallback(
    () => {
      if (triptype?.rf === "at" || triptype?.rf === "hr") return ""
      const stopOversStr = stopOvers?.map((stop, index) => {
        const str = stop?.value?.city_name || previousStopOvers[index]?.value?.city_name
        return str?.length ? str.charAt(0).toUpperCase() + str.slice(1) : null
      }).filter(Boolean).join(' - ')

      const placesStr = stopOversStr?.length && source?.city_name && destination?.city_name ? source?.city_name?.charAt(0).toUpperCase() + source?.city_name?.slice(1) + ` - ${stopOversStr}` + ` - ${destination?.city_name?.charAt(0).toUpperCase() + destination?.city_name?.slice(1)}` + `${triptype?.rf === "rt" ? ` - ${source?.city_name?.charAt(0).toUpperCase() + source?.city_name?.slice(1)}` : ""}` : ""
      const tripDaysStr =  startDate && endDate && +getTripDays(startDate.date, endDate.date, true, true) > 0 ? `${getTripDays(startDate.date, endDate.date, true, true)} ${+getTripDays(startDate.date, endDate.date, true) > 1 ? `days` : `day`}` : ''
      let finalStrArr = []
      if (placesStr?.length) {
        finalStrArr = [`Your multicity ${triptype?.rf === "ow" ? "one-way" : "round-trip"} ${tripDaysStr?.length ? ` plan : ` : ""}`, `${tripDaysStr} | ${placesStr}`]
      }
      return finalStrArr
    }, [source?.city_name, destination?.city_name, stopOvers, triptype, startDate, endDate]
  )

  const searchWidgetHeight = useMemo(() => {
    if (!configData?.multicity || triptype?.rf === "at" || triptype?.rf === "hr") {
      return triptype?.rf === "rt" ? '45rem' : "37rem"
    } else {
      switch (stopOvers?.length) {

        case 1 : 
          return stopOversStr()?.length && formError?.stopOversError?.length ? '62rem' : stopOversStr()?.length && !formError?.stopOversError?.length ? '61rem' : '55rem'
          
        case 2 :
          return stopOversStr()?.length && formError?.stopOversError?.length ? '72rem' : stopOversStr()?.length && !formError?.stopOversError?.length ? '70rem' : '63rem'

        case 3 :
          return stopOversStr()?.length && formError?.stopOversError?.length ? '80rem' : stopOversStr()?.length && !formError?.stopOversError?.length ? '77rem' : '70rem'

        case 4 :
          return stopOversStr()?.length && formError?.stopOversError?.length ? '86rem' : stopOversStr()?.length && !formError?.stopOversError?.length ? '84rem' : '77rem'

        case 5 :
          return  stopOversStr()?.length && formError?.stopOversError?.length ? '90rem' : stopOversStr()?.length && !formError?.stopOversError?.length ? '88rem' : '81rem'

        default :
          return triptype?.rf === "rt" ? '48rem' : "41rem"
      }
    }
  }, [stopOvers, triptype?.rf, stopOversStr(), formError?.stopOversError]);

  const onAddStopsClick = () => {
    const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
    const newStop = {
      id : newStopOvers.length + 1,
      value: {}
    }
    newStopOvers.push(newStop)
    pushCtaOmniEvents(`${MOB_CABS_LANDING}_${ADD_STOP}_${newStopOvers.length + 1}_${CLICKED}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
    dispatch({
      type: UPDATE_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })
  }

  const onStopClearClick = (id) => {
    const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
    if (newStopOvers.length === 1) {
      newStopOvers.splice(0, 1)
    } else if (id === newStopOvers.length) {
      newStopOvers.pop()
    } else {
      newStopOvers.splice(id, 1)
      for (let i = id; i < newStopOvers.length; i++) {
        newStopOvers[i].id = i + 1;
      }
    }
    pushCtaOmniEvents(`${MOB_CABS_LANDING}_${REMOVE_STOP}_${id + 1}_${CLICKED}`, CTA_TYPE.BUTTON, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)

    dispatch({
      type: UPDATE_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })

    dispatch({
      type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })
  }

  return (
    <S.SearchWidgetWrap
      height={searchWidgetHeight}
      ref={searchWidgetRef}
    >
      <S.OptionWrap>
        {tripAttributes?.map(({ name, sName, tripType, rf }, index) => {
          const isActive = !!(triptype?.name === tripType);
          return (
            <S.CustomRadioWrap
              id={`${name}-${sName}`}
              onClick={() => updateTripType(tripType, rf)}
              key={`tripAttributes${index}`}
            >
              <CustomRadioButton isActive={isActive} />
              <S.labelTxt
                style={isActive ? { color: "#2276e3" } : { color: "#4f525a" }}
              >
                {name} <br />
                {sName}
              </S.labelTxt>
            </S.CustomRadioWrap>
          );
        }) || null}
      </S.OptionWrap>
      <AutoSuggest label={"source"} labelVal={"From"} title={source?.name || ""} type={triptype?.rf} popularSearch={popularSearch} autoFocus={!!(!source?.name && !destination?.name)} invokedFor={gcHomeScreen} />
      {formError?.pickupError ? (
        <S.ErrorContainer>
          {formError?.pickupError}
        </S.ErrorContainer>
      ) : null}
      {triptype?.rf !== 'hr' ? (
        <>
          <S.SwapIconWrap error={formError?.stopOversError?.length} style={{ zIndex: 2 }} onClick={() => onSwap()}>
            <Icon
              name="SwapIcon"
              styleProps={{
                fill: "#647a97",
                width: "3.2rem",
                height: "3.2rem"
              }}
            />
          </S.SwapIconWrap>
          <AutoSuggest label={"destination"} labelVal={"To"} title={destination?.name || ""} type={triptype?.rf} popularSearch={popularSearch} autoFocus={!!(source?.name && !destination?.name)} invokedFor={gcHomeScreen} />
          {formError?.dropError ? (
            <S.ErrorContainer>
              {formError?.dropError}
            </S.ErrorContainer>
          ) : null}
        </>
      ) : null}
      {stopOversStr()?.length ? (
        <S.MulticityStopsText>
          <span>
            {stopOversStr()?.[0]}
          </span>
          <span className="darkTxt">
            {stopOversStr()?.[1]}
          </span>
        </S.MulticityStopsText>
      ) : null}
      {stopOvers?.length && triptype?.rf !== "at" && triptype?.rf !== "hr" ? (
        <>
          {stopOvers.map((details, index) => (
            <S.StopOversCont tabIndex={index}>
              <div style={{width: "100%"}}>
                <AutoSuggest width="98%" label={`Stop ${details?.id}`} labelVal={`Stop ${details?.id}`} title={details?.value?.name || ""} type={triptype?.rf} popularSearch={popularSearch} invokedFor={gcHomeScreen} placeVal={`Enter stop ${details?.id}`} id={details?.id} autoFocus={index === autofocusIndex && source?.name && destination?.name} />
                {formError?.stopOversError && !details?.value?.name ? (
                  <S.ErrorContainer>
                    {formError?.stopOversError}
                  </S.ErrorContainer>
                ) : null}
              </div>
              <S.CloseCont onClick={() => onStopClearClick(index)}>
                <span className="close"></span>
              </S.CloseCont>
            </S.StopOversCont>
          ))}
        </>
      ) : null}
      <>
      {configData?.multicity && stopOvers?.length < configData?.multicity && triptype?.rf !== "at" && triptype?.rf !== "hr" ? (
        <S.StopoversTextCont onClick={onAddStopsClick}>
          + Add Stops
          <span>
            New
          </span>
        </S.StopoversTextCont>
      ) : null}
      </>
      <S.CalendarBlock>
        <S.PickupDate
          onClick={() => {
            if (!showWidget) {
              pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, PICKUP_DATE_CALANDER), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
              setWidget("pickcalendar") 
            }
          }}
        >
          {showWidget === "pickcalendar" ? (
            <Calendar toggleCalendar={setWidget} invokedFor={gcHomeScreen} isMulticity={configData?.multicity && triptype?.rf !== "at" && triptype?.rf !== "hr"} />
          ) : null}
          <label>Pickup Date</label>
          <S.DateTxt>{dateformat(date, "dd mmm' yy")}</S.DateTxt>
        </S.PickupDate>
        <S.PickupTime
          onClick={() => {
            if (!showWidget) {
              pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, PICKUP_TIME_CALANDER), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
              setWidget("picktime")
            }
          }}
        >
          <label>Pickup Time</label>
          <S.DateTxt>{time}</S.DateTxt>
          {showWidget === "picktime" ? (
            <TimeDropdown date={date} time={time} updateTime={updateTime} pickupTime={time} pickupDate={date}/>
          ) : null}
        </S.PickupTime>
      </S.CalendarBlock>
      {((triptype?.rf === "rt" || (configData?.multicity && stopOvers?.length)) && triptype?.rf !== "hr" && triptype?.rf !== "at") ? (
        <S.CalendarBlock>
          <S.PickupDate
            onClick={() => {
              if (!showWidget) {
                pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, RETURN_DATE_CALANDER), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
                setWidget("returncalendar")
              }
            }}
          >
            {showWidget === "returncalendar" ? (
              <Calendar toggleCalendar={setWidget} isPickUp={false} invokedFor={gcHomeScreen} isMulticity={configData?.multicity && triptype?.rf !== "at" && triptype?.rf !== "hr"} />
            ) : null}
            <label>Return Date</label>
            <S.DateTxt>{dateformat(enddate, "dd mmm' yy")}</S.DateTxt>
          </S.PickupDate>
          <S.PickupTime
            onClick={() => {
              if (!showWidget) {
                pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, RETURN_TIME_CALANDER), CTA_TYPE.HYPER_LINK, HOME_SEARCH_WIDGET, CABS_LANDING_ROUTE)
                setWidget("returntime")
              }
            }}
            onMouseEnter={() => {
              {isRTRevamp && triptype?.rf === "rt" && setWidget("returntime")}
            }}
            onMouseLeave={() => {
              {isRTRevamp && triptype?.rf === "rt" && setWidget("")}
            }}
          >
            <label>Return Time</label>
            {isRTRevamp && triptype?.rf === "rt" ? <S.RtDateText>{rtText}</S.RtDateText> : <S.DateTxt>{endTime}</S.DateTxt>}
            {showWidget === "returntime" && !(isRTRevamp && triptype?.rf === "rt" ) ? (
              <TimeDropdown
                date={enddate}
                time={endTime}
                updateTime={updateTime}
                isPickup={false}
                initialTime={date?.toDateString() === enddate?.toDateString() ? time : null}
                pickupTime={time}
                pickupDate={date}
              />
            ) : null}
            {showWidget === "returntime" && isRTRevamp && triptype?.rf === "rt"  ? (
              <S.ToastContainer>
                <S.ToastArrow />
                <S.ToastText>{rtRevampText}</S.ToastText>
              </S.ToastContainer>
            ):null}
          </S.PickupTime>
        </S.CalendarBlock>
      ) : null}
      {triptype?.rf === 'hr' ? (
        <>
          <S.HrPackageWrapper>
            <CabHourlyCarouselUI data={hrPackageDetails?.packages} invokedFor={gcHomeScreen} />
          </S.HrPackageWrapper>
          <>
            {formError?.packageError ? (
              <S.ErrorContainer>
                {formError?.packageError}
              </S.ErrorContainer>
            ) : null}
          </>
        </>
      ) : null}
      <S.ButtonWrap onClick={() => onSearch()}>
        <button>SEARCH CABS</button>
      </S.ButtonWrap>
    </S.SearchWidgetWrap>
  );
};

export default React.memo(HomeSearchWidget);